import "../../styles/layout.scss";
import logo from "../../assets/logo.svg";
import { Avatar, Box, Button, IconButton, Tooltip } from "@mui/material";
import { $isAuth } from "../../store/isAuthStore"
import { useUnit } from "effector-react"
import { Login } from "@mui/icons-material";

export const Header = () => {
    const isAuth = useUnit($isAuth);

    const handleClick = () => {
        window.location.href = "/userProfile";
    };

    const goToAuthorization = () => {
        window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
    }

    return (

        <div className="layout__header">
            {isAuth
                ? <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <Tooltip title="Account settings">
                        <IconButton
                            onClick={handleClick}
                            size="small"
                            sx={{ ml: 2 }}
                        >
                            <Avatar sx={{ width: 32, height: 32 }}>M</Avatar>
                        </IconButton>
                    </Tooltip>
                </Box>
                : <Button onClick={goToAuthorization}>
                    Вход <Login />
                </Button>
            }
            <img className="layout__header__logo" src={logo} alt="Логотип" />
            <div style={{ width: "58px" }}></div>
        </div>
    )
}